//@ts-nocheck
import { Params } from "./params";
import { Subscription, FutureSubscription } from "./subscription";
import { Coin, DecCoin } from "../../../cosmos/base/v1beta1/coin";
import { TrackedCuInfo } from "./cu_tracker";
import { BinaryReader, BinaryWriter } from "../../../binary";
import { isSet } from "../../../helpers";
import { GlobalDecoderRegistry } from "../../../registry";
function createBaseQueryParamsRequest() {
    return {};
}
export const QueryParamsRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryParamsRequest",
    is(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryParamsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryParamsRequest",
            value: QueryParamsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsRequest.typeUrl, QueryParamsRequest);
function createBaseQueryParamsResponse() {
    return {
        params: Params.fromPartial({})
    };
}
export const QueryParamsResponse = {
    typeUrl: "/lavanet.lava.subscription.QueryParamsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.is(o.params));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isSDK(o.params));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isAmino(o.params));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? Params.fromJSON(object.params) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryParamsResponse();
        if (object.params !== undefined && object.params !== null) {
            message.params = Params.fromAmino(object.params);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.params = message.params ? Params.toAmino(message.params) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryParamsResponse",
            value: QueryParamsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsResponse.typeUrl, QueryParamsResponse);
function createBaseQueryCurrentRequest() {
    return {
        consumer: ""
    };
}
export const QueryCurrentRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryCurrentRequest",
    is(o) {
        return o && (o.$typeUrl === QueryCurrentRequest.typeUrl || typeof o.consumer === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryCurrentRequest.typeUrl || typeof o.consumer === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryCurrentRequest.typeUrl || typeof o.consumer === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.consumer !== "") {
            writer.uint32(10).string(message.consumer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCurrentRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consumer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consumer: isSet(object.consumer) ? String(object.consumer) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.consumer !== undefined && (obj.consumer = message.consumer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCurrentRequest();
        message.consumer = object.consumer ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryCurrentRequest();
        if (object.consumer !== undefined && object.consumer !== null) {
            message.consumer = object.consumer;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.consumer = message.consumer === "" ? undefined : message.consumer;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryCurrentRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryCurrentRequest.decode(message.value);
    },
    toProto(message) {
        return QueryCurrentRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryCurrentRequest",
            value: QueryCurrentRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryCurrentRequest.typeUrl, QueryCurrentRequest);
function createBaseQueryCurrentResponse() {
    return {
        sub: undefined
    };
}
export const QueryCurrentResponse = {
    typeUrl: "/lavanet.lava.subscription.QueryCurrentResponse",
    is(o) {
        return o && o.$typeUrl === QueryCurrentResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryCurrentResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryCurrentResponse.typeUrl;
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.sub !== undefined) {
            Subscription.encode(message.sub, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCurrentResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sub = Subscription.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            sub: isSet(object.sub) ? Subscription.fromJSON(object.sub) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.sub !== undefined && (obj.sub = message.sub ? Subscription.toJSON(message.sub) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCurrentResponse();
        message.sub = object.sub !== undefined && object.sub !== null ? Subscription.fromPartial(object.sub) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryCurrentResponse();
        if (object.sub !== undefined && object.sub !== null) {
            message.sub = Subscription.fromAmino(object.sub);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.sub = message.sub ? Subscription.toAmino(message.sub) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryCurrentResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryCurrentResponse.decode(message.value);
    },
    toProto(message) {
        return QueryCurrentResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryCurrentResponse",
            value: QueryCurrentResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryCurrentResponse.typeUrl, QueryCurrentResponse);
function createBaseQueryListProjectsRequest() {
    return {
        subscription: ""
    };
}
export const QueryListProjectsRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryListProjectsRequest",
    is(o) {
        return o && (o.$typeUrl === QueryListProjectsRequest.typeUrl || typeof o.subscription === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryListProjectsRequest.typeUrl || typeof o.subscription === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryListProjectsRequest.typeUrl || typeof o.subscription === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.subscription !== "") {
            writer.uint32(10).string(message.subscription);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryListProjectsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subscription = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subscription: isSet(object.subscription) ? String(object.subscription) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.subscription !== undefined && (obj.subscription = message.subscription);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryListProjectsRequest();
        message.subscription = object.subscription ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryListProjectsRequest();
        if (object.subscription !== undefined && object.subscription !== null) {
            message.subscription = object.subscription;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.subscription = message.subscription === "" ? undefined : message.subscription;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryListProjectsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryListProjectsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryListProjectsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryListProjectsRequest",
            value: QueryListProjectsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryListProjectsRequest.typeUrl, QueryListProjectsRequest);
function createBaseQueryListProjectsResponse() {
    return {
        projects: []
    };
}
export const QueryListProjectsResponse = {
    typeUrl: "/lavanet.lava.subscription.QueryListProjectsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryListProjectsResponse.typeUrl || Array.isArray(o.projects) && (!o.projects.length || typeof o.projects[0] === "string"));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryListProjectsResponse.typeUrl || Array.isArray(o.projects) && (!o.projects.length || typeof o.projects[0] === "string"));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryListProjectsResponse.typeUrl || Array.isArray(o.projects) && (!o.projects.length || typeof o.projects[0] === "string"));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.projects) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryListProjectsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.projects.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            projects: Array.isArray(object?.projects) ? object.projects.map((e) => String(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.projects) {
            obj.projects = message.projects.map(e => e);
        }
        else {
            obj.projects = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryListProjectsResponse();
        message.projects = object.projects?.map(e => e) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryListProjectsResponse();
        message.projects = object.projects?.map(e => e) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.projects) {
            obj.projects = message.projects.map(e => e);
        }
        else {
            obj.projects = message.projects;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryListProjectsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryListProjectsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryListProjectsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryListProjectsResponse",
            value: QueryListProjectsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryListProjectsResponse.typeUrl, QueryListProjectsResponse);
function createBaseQueryListRequest() {
    return {};
}
export const QueryListRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryListRequest",
    is(o) {
        return o && o.$typeUrl === QueryListRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryListRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryListRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryListRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryListRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryListRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryListRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryListRequest.decode(message.value);
    },
    toProto(message) {
        return QueryListRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryListRequest",
            value: QueryListRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryListRequest.typeUrl, QueryListRequest);
function createBaseQueryListResponse() {
    return {
        subsInfo: []
    };
}
export const QueryListResponse = {
    typeUrl: "/lavanet.lava.subscription.QueryListResponse",
    is(o) {
        return o && (o.$typeUrl === QueryListResponse.typeUrl || Array.isArray(o.subsInfo) && (!o.subsInfo.length || ListInfoStruct.is(o.subsInfo[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryListResponse.typeUrl || Array.isArray(o.subs_info) && (!o.subs_info.length || ListInfoStruct.isSDK(o.subs_info[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryListResponse.typeUrl || Array.isArray(o.subs_info) && (!o.subs_info.length || ListInfoStruct.isAmino(o.subs_info[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.subsInfo) {
            ListInfoStruct.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryListResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subsInfo.push(ListInfoStruct.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subsInfo: Array.isArray(object?.subsInfo) ? object.subsInfo.map((e) => ListInfoStruct.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subsInfo) {
            obj.subsInfo = message.subsInfo.map(e => e ? ListInfoStruct.toJSON(e) : undefined);
        }
        else {
            obj.subsInfo = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryListResponse();
        message.subsInfo = object.subsInfo?.map(e => ListInfoStruct.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryListResponse();
        message.subsInfo = object.subs_info?.map(e => ListInfoStruct.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.subsInfo) {
            obj.subs_info = message.subsInfo.map(e => e ? ListInfoStruct.toAmino(e) : undefined);
        }
        else {
            obj.subs_info = message.subsInfo;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryListResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryListResponse.decode(message.value);
    },
    toProto(message) {
        return QueryListResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryListResponse",
            value: QueryListResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryListResponse.typeUrl, QueryListResponse);
function createBaseListInfoStruct() {
    return {
        consumer: "",
        plan: "",
        durationBought: BigInt(0),
        durationLeft: BigInt(0),
        monthExpiry: BigInt(0),
        monthCuTotal: BigInt(0),
        monthCuLeft: BigInt(0),
        cluster: "",
        durationTotal: BigInt(0),
        autoRenewalNextPlan: "",
        futureSubscription: undefined,
        credit: undefined
    };
}
export const ListInfoStruct = {
    typeUrl: "/lavanet.lava.subscription.ListInfoStruct",
    is(o) {
        return o && (o.$typeUrl === ListInfoStruct.typeUrl || typeof o.consumer === "string" && typeof o.plan === "string" && typeof o.durationBought === "bigint" && typeof o.durationLeft === "bigint" && typeof o.monthExpiry === "bigint" && typeof o.monthCuTotal === "bigint" && typeof o.monthCuLeft === "bigint" && typeof o.cluster === "string" && typeof o.durationTotal === "bigint" && typeof o.autoRenewalNextPlan === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === ListInfoStruct.typeUrl || typeof o.consumer === "string" && typeof o.plan === "string" && typeof o.duration_bought === "bigint" && typeof o.duration_left === "bigint" && typeof o.month_expiry === "bigint" && typeof o.month_cu_total === "bigint" && typeof o.month_cu_left === "bigint" && typeof o.cluster === "string" && typeof o.duration_total === "bigint" && typeof o.auto_renewal_next_plan === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === ListInfoStruct.typeUrl || typeof o.consumer === "string" && typeof o.plan === "string" && typeof o.duration_bought === "bigint" && typeof o.duration_left === "bigint" && typeof o.month_expiry === "bigint" && typeof o.month_cu_total === "bigint" && typeof o.month_cu_left === "bigint" && typeof o.cluster === "string" && typeof o.duration_total === "bigint" && typeof o.auto_renewal_next_plan === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.consumer !== "") {
            writer.uint32(10).string(message.consumer);
        }
        if (message.plan !== "") {
            writer.uint32(18).string(message.plan);
        }
        if (message.durationBought !== BigInt(0)) {
            writer.uint32(24).uint64(message.durationBought);
        }
        if (message.durationLeft !== BigInt(0)) {
            writer.uint32(32).uint64(message.durationLeft);
        }
        if (message.monthExpiry !== BigInt(0)) {
            writer.uint32(40).uint64(message.monthExpiry);
        }
        if (message.monthCuTotal !== BigInt(0)) {
            writer.uint32(48).uint64(message.monthCuTotal);
        }
        if (message.monthCuLeft !== BigInt(0)) {
            writer.uint32(56).uint64(message.monthCuLeft);
        }
        if (message.cluster !== "") {
            writer.uint32(66).string(message.cluster);
        }
        if (message.durationTotal !== BigInt(0)) {
            writer.uint32(72).uint64(message.durationTotal);
        }
        if (message.autoRenewalNextPlan !== "") {
            writer.uint32(90).string(message.autoRenewalNextPlan);
        }
        if (message.futureSubscription !== undefined) {
            FutureSubscription.encode(message.futureSubscription, writer.uint32(98).fork()).ldelim();
        }
        if (message.credit !== undefined) {
            Coin.encode(message.credit, writer.uint32(106).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListInfoStruct();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consumer = reader.string();
                    break;
                case 2:
                    message.plan = reader.string();
                    break;
                case 3:
                    message.durationBought = reader.uint64();
                    break;
                case 4:
                    message.durationLeft = reader.uint64();
                    break;
                case 5:
                    message.monthExpiry = reader.uint64();
                    break;
                case 6:
                    message.monthCuTotal = reader.uint64();
                    break;
                case 7:
                    message.monthCuLeft = reader.uint64();
                    break;
                case 8:
                    message.cluster = reader.string();
                    break;
                case 9:
                    message.durationTotal = reader.uint64();
                    break;
                case 11:
                    message.autoRenewalNextPlan = reader.string();
                    break;
                case 12:
                    message.futureSubscription = FutureSubscription.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.credit = Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consumer: isSet(object.consumer) ? String(object.consumer) : "",
            plan: isSet(object.plan) ? String(object.plan) : "",
            durationBought: isSet(object.durationBought) ? BigInt(object.durationBought.toString()) : BigInt(0),
            durationLeft: isSet(object.durationLeft) ? BigInt(object.durationLeft.toString()) : BigInt(0),
            monthExpiry: isSet(object.monthExpiry) ? BigInt(object.monthExpiry.toString()) : BigInt(0),
            monthCuTotal: isSet(object.monthCuTotal) ? BigInt(object.monthCuTotal.toString()) : BigInt(0),
            monthCuLeft: isSet(object.monthCuLeft) ? BigInt(object.monthCuLeft.toString()) : BigInt(0),
            cluster: isSet(object.cluster) ? String(object.cluster) : "",
            durationTotal: isSet(object.durationTotal) ? BigInt(object.durationTotal.toString()) : BigInt(0),
            autoRenewalNextPlan: isSet(object.autoRenewalNextPlan) ? String(object.autoRenewalNextPlan) : "",
            futureSubscription: isSet(object.futureSubscription) ? FutureSubscription.fromJSON(object.futureSubscription) : undefined,
            credit: isSet(object.credit) ? Coin.fromJSON(object.credit) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.consumer !== undefined && (obj.consumer = message.consumer);
        message.plan !== undefined && (obj.plan = message.plan);
        message.durationBought !== undefined && (obj.durationBought = (message.durationBought || BigInt(0)).toString());
        message.durationLeft !== undefined && (obj.durationLeft = (message.durationLeft || BigInt(0)).toString());
        message.monthExpiry !== undefined && (obj.monthExpiry = (message.monthExpiry || BigInt(0)).toString());
        message.monthCuTotal !== undefined && (obj.monthCuTotal = (message.monthCuTotal || BigInt(0)).toString());
        message.monthCuLeft !== undefined && (obj.monthCuLeft = (message.monthCuLeft || BigInt(0)).toString());
        message.cluster !== undefined && (obj.cluster = message.cluster);
        message.durationTotal !== undefined && (obj.durationTotal = (message.durationTotal || BigInt(0)).toString());
        message.autoRenewalNextPlan !== undefined && (obj.autoRenewalNextPlan = message.autoRenewalNextPlan);
        message.futureSubscription !== undefined && (obj.futureSubscription = message.futureSubscription ? FutureSubscription.toJSON(message.futureSubscription) : undefined);
        message.credit !== undefined && (obj.credit = message.credit ? Coin.toJSON(message.credit) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseListInfoStruct();
        message.consumer = object.consumer ?? "";
        message.plan = object.plan ?? "";
        message.durationBought = object.durationBought !== undefined && object.durationBought !== null ? BigInt(object.durationBought.toString()) : BigInt(0);
        message.durationLeft = object.durationLeft !== undefined && object.durationLeft !== null ? BigInt(object.durationLeft.toString()) : BigInt(0);
        message.monthExpiry = object.monthExpiry !== undefined && object.monthExpiry !== null ? BigInt(object.monthExpiry.toString()) : BigInt(0);
        message.monthCuTotal = object.monthCuTotal !== undefined && object.monthCuTotal !== null ? BigInt(object.monthCuTotal.toString()) : BigInt(0);
        message.monthCuLeft = object.monthCuLeft !== undefined && object.monthCuLeft !== null ? BigInt(object.monthCuLeft.toString()) : BigInt(0);
        message.cluster = object.cluster ?? "";
        message.durationTotal = object.durationTotal !== undefined && object.durationTotal !== null ? BigInt(object.durationTotal.toString()) : BigInt(0);
        message.autoRenewalNextPlan = object.autoRenewalNextPlan ?? "";
        message.futureSubscription = object.futureSubscription !== undefined && object.futureSubscription !== null ? FutureSubscription.fromPartial(object.futureSubscription) : undefined;
        message.credit = object.credit !== undefined && object.credit !== null ? Coin.fromPartial(object.credit) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseListInfoStruct();
        if (object.consumer !== undefined && object.consumer !== null) {
            message.consumer = object.consumer;
        }
        if (object.plan !== undefined && object.plan !== null) {
            message.plan = object.plan;
        }
        if (object.duration_bought !== undefined && object.duration_bought !== null) {
            message.durationBought = BigInt(object.duration_bought);
        }
        if (object.duration_left !== undefined && object.duration_left !== null) {
            message.durationLeft = BigInt(object.duration_left);
        }
        if (object.month_expiry !== undefined && object.month_expiry !== null) {
            message.monthExpiry = BigInt(object.month_expiry);
        }
        if (object.month_cu_total !== undefined && object.month_cu_total !== null) {
            message.monthCuTotal = BigInt(object.month_cu_total);
        }
        if (object.month_cu_left !== undefined && object.month_cu_left !== null) {
            message.monthCuLeft = BigInt(object.month_cu_left);
        }
        if (object.cluster !== undefined && object.cluster !== null) {
            message.cluster = object.cluster;
        }
        if (object.duration_total !== undefined && object.duration_total !== null) {
            message.durationTotal = BigInt(object.duration_total);
        }
        if (object.auto_renewal_next_plan !== undefined && object.auto_renewal_next_plan !== null) {
            message.autoRenewalNextPlan = object.auto_renewal_next_plan;
        }
        if (object.future_subscription !== undefined && object.future_subscription !== null) {
            message.futureSubscription = FutureSubscription.fromAmino(object.future_subscription);
        }
        if (object.credit !== undefined && object.credit !== null) {
            message.credit = Coin.fromAmino(object.credit);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.consumer = message.consumer === "" ? undefined : message.consumer;
        obj.plan = message.plan === "" ? undefined : message.plan;
        obj.duration_bought = message.durationBought !== BigInt(0) ? (message.durationBought?.toString)() : undefined;
        obj.duration_left = message.durationLeft !== BigInt(0) ? (message.durationLeft?.toString)() : undefined;
        obj.month_expiry = message.monthExpiry !== BigInt(0) ? (message.monthExpiry?.toString)() : undefined;
        obj.month_cu_total = message.monthCuTotal !== BigInt(0) ? (message.monthCuTotal?.toString)() : undefined;
        obj.month_cu_left = message.monthCuLeft !== BigInt(0) ? (message.monthCuLeft?.toString)() : undefined;
        obj.cluster = message.cluster === "" ? undefined : message.cluster;
        obj.duration_total = message.durationTotal !== BigInt(0) ? (message.durationTotal?.toString)() : undefined;
        obj.auto_renewal_next_plan = message.autoRenewalNextPlan === "" ? undefined : message.autoRenewalNextPlan;
        obj.future_subscription = message.futureSubscription ? FutureSubscription.toAmino(message.futureSubscription) : undefined;
        obj.credit = message.credit ? Coin.toAmino(message.credit) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return ListInfoStruct.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return ListInfoStruct.decode(message.value);
    },
    toProto(message) {
        return ListInfoStruct.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.ListInfoStruct",
            value: ListInfoStruct.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(ListInfoStruct.typeUrl, ListInfoStruct);
function createBaseQueryNextToMonthExpiryRequest() {
    return {};
}
export const QueryNextToMonthExpiryRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryNextToMonthExpiryRequest",
    is(o) {
        return o && o.$typeUrl === QueryNextToMonthExpiryRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryNextToMonthExpiryRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryNextToMonthExpiryRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNextToMonthExpiryRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryNextToMonthExpiryRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryNextToMonthExpiryRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryNextToMonthExpiryRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryNextToMonthExpiryRequest.decode(message.value);
    },
    toProto(message) {
        return QueryNextToMonthExpiryRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryNextToMonthExpiryRequest",
            value: QueryNextToMonthExpiryRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryNextToMonthExpiryRequest.typeUrl, QueryNextToMonthExpiryRequest);
function createBaseTimerExpiryInfo() {
    return {
        consumer: "",
        monthExpiry: BigInt(0)
    };
}
export const TimerExpiryInfo = {
    typeUrl: "/lavanet.lava.subscription.TimerExpiryInfo",
    is(o) {
        return o && (o.$typeUrl === TimerExpiryInfo.typeUrl || typeof o.consumer === "string" && typeof o.monthExpiry === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === TimerExpiryInfo.typeUrl || typeof o.consumer === "string" && typeof o.month_expiry === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === TimerExpiryInfo.typeUrl || typeof o.consumer === "string" && typeof o.month_expiry === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.consumer !== "") {
            writer.uint32(10).string(message.consumer);
        }
        if (message.monthExpiry !== BigInt(0)) {
            writer.uint32(16).uint64(message.monthExpiry);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTimerExpiryInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.consumer = reader.string();
                    break;
                case 2:
                    message.monthExpiry = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            consumer: isSet(object.consumer) ? String(object.consumer) : "",
            monthExpiry: isSet(object.monthExpiry) ? BigInt(object.monthExpiry.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.consumer !== undefined && (obj.consumer = message.consumer);
        message.monthExpiry !== undefined && (obj.monthExpiry = (message.monthExpiry || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTimerExpiryInfo();
        message.consumer = object.consumer ?? "";
        message.monthExpiry = object.monthExpiry !== undefined && object.monthExpiry !== null ? BigInt(object.monthExpiry.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseTimerExpiryInfo();
        if (object.consumer !== undefined && object.consumer !== null) {
            message.consumer = object.consumer;
        }
        if (object.month_expiry !== undefined && object.month_expiry !== null) {
            message.monthExpiry = BigInt(object.month_expiry);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.consumer = message.consumer === "" ? undefined : message.consumer;
        obj.month_expiry = message.monthExpiry !== BigInt(0) ? (message.monthExpiry?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return TimerExpiryInfo.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return TimerExpiryInfo.decode(message.value);
    },
    toProto(message) {
        return TimerExpiryInfo.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.TimerExpiryInfo",
            value: TimerExpiryInfo.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(TimerExpiryInfo.typeUrl, TimerExpiryInfo);
function createBaseQueryNextToMonthExpiryResponse() {
    return {
        subscriptions: []
    };
}
export const QueryNextToMonthExpiryResponse = {
    typeUrl: "/lavanet.lava.subscription.QueryNextToMonthExpiryResponse",
    is(o) {
        return o && (o.$typeUrl === QueryNextToMonthExpiryResponse.typeUrl || Array.isArray(o.subscriptions) && (!o.subscriptions.length || TimerExpiryInfo.is(o.subscriptions[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryNextToMonthExpiryResponse.typeUrl || Array.isArray(o.subscriptions) && (!o.subscriptions.length || TimerExpiryInfo.isSDK(o.subscriptions[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryNextToMonthExpiryResponse.typeUrl || Array.isArray(o.subscriptions) && (!o.subscriptions.length || TimerExpiryInfo.isAmino(o.subscriptions[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.subscriptions) {
            TimerExpiryInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryNextToMonthExpiryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subscriptions.push(TimerExpiryInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subscriptions: Array.isArray(object?.subscriptions) ? object.subscriptions.map((e) => TimerExpiryInfo.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.subscriptions) {
            obj.subscriptions = message.subscriptions.map(e => e ? TimerExpiryInfo.toJSON(e) : undefined);
        }
        else {
            obj.subscriptions = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryNextToMonthExpiryResponse();
        message.subscriptions = object.subscriptions?.map(e => TimerExpiryInfo.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryNextToMonthExpiryResponse();
        message.subscriptions = object.subscriptions?.map(e => TimerExpiryInfo.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.subscriptions) {
            obj.subscriptions = message.subscriptions.map(e => e ? TimerExpiryInfo.toAmino(e) : undefined);
        }
        else {
            obj.subscriptions = message.subscriptions;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryNextToMonthExpiryResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryNextToMonthExpiryResponse.decode(message.value);
    },
    toProto(message) {
        return QueryNextToMonthExpiryResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryNextToMonthExpiryResponse",
            value: QueryNextToMonthExpiryResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryNextToMonthExpiryResponse.typeUrl, QueryNextToMonthExpiryResponse);
function createBaseQuerySubscriptionTrackedUsageRequest() {
    return {
        subscription: ""
    };
}
export const QuerySubscriptionTrackedUsageRequest = {
    typeUrl: "/lavanet.lava.subscription.QuerySubscriptionTrackedUsageRequest",
    is(o) {
        return o && (o.$typeUrl === QuerySubscriptionTrackedUsageRequest.typeUrl || typeof o.subscription === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QuerySubscriptionTrackedUsageRequest.typeUrl || typeof o.subscription === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QuerySubscriptionTrackedUsageRequest.typeUrl || typeof o.subscription === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.subscription !== "") {
            writer.uint32(10).string(message.subscription);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySubscriptionTrackedUsageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subscription = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subscription: isSet(object.subscription) ? String(object.subscription) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.subscription !== undefined && (obj.subscription = message.subscription);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySubscriptionTrackedUsageRequest();
        message.subscription = object.subscription ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQuerySubscriptionTrackedUsageRequest();
        if (object.subscription !== undefined && object.subscription !== null) {
            message.subscription = object.subscription;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.subscription = message.subscription === "" ? undefined : message.subscription;
        return obj;
    },
    fromAminoMsg(object) {
        return QuerySubscriptionTrackedUsageRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QuerySubscriptionTrackedUsageRequest.decode(message.value);
    },
    toProto(message) {
        return QuerySubscriptionTrackedUsageRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QuerySubscriptionTrackedUsageRequest",
            value: QuerySubscriptionTrackedUsageRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QuerySubscriptionTrackedUsageRequest.typeUrl, QuerySubscriptionTrackedUsageRequest);
function createBaseQuerySubscriptionTrackedUsageResponse() {
    return {
        subscription: undefined,
        usage: [],
        totalUsage: BigInt(0)
    };
}
export const QuerySubscriptionTrackedUsageResponse = {
    typeUrl: "/lavanet.lava.subscription.QuerySubscriptionTrackedUsageResponse",
    is(o) {
        return o && (o.$typeUrl === QuerySubscriptionTrackedUsageResponse.typeUrl || Array.isArray(o.usage) && (!o.usage.length || TrackedCuInfo.is(o.usage[0])) && typeof o.totalUsage === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QuerySubscriptionTrackedUsageResponse.typeUrl || Array.isArray(o.usage) && (!o.usage.length || TrackedCuInfo.isSDK(o.usage[0])) && typeof o.total_usage === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QuerySubscriptionTrackedUsageResponse.typeUrl || Array.isArray(o.usage) && (!o.usage.length || TrackedCuInfo.isAmino(o.usage[0])) && typeof o.total_usage === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.subscription !== undefined) {
            Subscription.encode(message.subscription, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.usage) {
            TrackedCuInfo.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.totalUsage !== BigInt(0)) {
            writer.uint32(24).uint64(message.totalUsage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQuerySubscriptionTrackedUsageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.subscription = Subscription.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.usage.push(TrackedCuInfo.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.totalUsage = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            subscription: isSet(object.subscription) ? Subscription.fromJSON(object.subscription) : undefined,
            usage: Array.isArray(object?.usage) ? object.usage.map((e) => TrackedCuInfo.fromJSON(e)) : [],
            totalUsage: isSet(object.totalUsage) ? BigInt(object.totalUsage.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.subscription !== undefined && (obj.subscription = message.subscription ? Subscription.toJSON(message.subscription) : undefined);
        if (message.usage) {
            obj.usage = message.usage.map(e => e ? TrackedCuInfo.toJSON(e) : undefined);
        }
        else {
            obj.usage = [];
        }
        message.totalUsage !== undefined && (obj.totalUsage = (message.totalUsage || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQuerySubscriptionTrackedUsageResponse();
        message.subscription = object.subscription !== undefined && object.subscription !== null ? Subscription.fromPartial(object.subscription) : undefined;
        message.usage = object.usage?.map(e => TrackedCuInfo.fromPartial(e)) || [];
        message.totalUsage = object.totalUsage !== undefined && object.totalUsage !== null ? BigInt(object.totalUsage.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseQuerySubscriptionTrackedUsageResponse();
        if (object.subscription !== undefined && object.subscription !== null) {
            message.subscription = Subscription.fromAmino(object.subscription);
        }
        message.usage = object.usage?.map(e => TrackedCuInfo.fromAmino(e)) || [];
        if (object.total_usage !== undefined && object.total_usage !== null) {
            message.totalUsage = BigInt(object.total_usage);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.subscription = message.subscription ? Subscription.toAmino(message.subscription) : undefined;
        if (message.usage) {
            obj.usage = message.usage.map(e => e ? TrackedCuInfo.toAmino(e) : undefined);
        }
        else {
            obj.usage = message.usage;
        }
        obj.total_usage = message.totalUsage !== BigInt(0) ? (message.totalUsage?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QuerySubscriptionTrackedUsageResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QuerySubscriptionTrackedUsageResponse.decode(message.value);
    },
    toProto(message) {
        return QuerySubscriptionTrackedUsageResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QuerySubscriptionTrackedUsageResponse",
            value: QuerySubscriptionTrackedUsageResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QuerySubscriptionTrackedUsageResponse.typeUrl, QuerySubscriptionTrackedUsageResponse);
function createBaseQueryEstimatedRewardsRequest() {
    return {
        provider: "",
        chainId: "",
        amountDelegator: ""
    };
}
export const QueryEstimatedRewardsRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryEstimatedRewardsRequest",
    is(o) {
        return o && (o.$typeUrl === QueryEstimatedRewardsRequest.typeUrl || typeof o.provider === "string" && typeof o.chainId === "string" && typeof o.amountDelegator === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEstimatedRewardsRequest.typeUrl || typeof o.provider === "string" && typeof o.chain_id === "string" && typeof o.amount_delegator === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEstimatedRewardsRequest.typeUrl || typeof o.provider === "string" && typeof o.chain_id === "string" && typeof o.amount_delegator === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.provider !== "") {
            writer.uint32(10).string(message.provider);
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.amountDelegator !== "") {
            writer.uint32(26).string(message.amountDelegator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEstimatedRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.provider = reader.string();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.amountDelegator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            provider: isSet(object.provider) ? String(object.provider) : "",
            chainId: isSet(object.chainId) ? String(object.chainId) : "",
            amountDelegator: isSet(object.amountDelegator) ? String(object.amountDelegator) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.provider !== undefined && (obj.provider = message.provider);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.amountDelegator !== undefined && (obj.amountDelegator = message.amountDelegator);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEstimatedRewardsRequest();
        message.provider = object.provider ?? "";
        message.chainId = object.chainId ?? "";
        message.amountDelegator = object.amountDelegator ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEstimatedRewardsRequest();
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.chain_id !== undefined && object.chain_id !== null) {
            message.chainId = object.chain_id;
        }
        if (object.amount_delegator !== undefined && object.amount_delegator !== null) {
            message.amountDelegator = object.amount_delegator;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.chain_id = message.chainId === "" ? undefined : message.chainId;
        obj.amount_delegator = message.amountDelegator === "" ? undefined : message.amountDelegator;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEstimatedRewardsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEstimatedRewardsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryEstimatedRewardsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryEstimatedRewardsRequest",
            value: QueryEstimatedRewardsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEstimatedRewardsRequest.typeUrl, QueryEstimatedRewardsRequest);
function createBaseQueryEstimatedProviderRewardsRequest() {
    return {
        provider: "",
        amountDelegator: ""
    };
}
export const QueryEstimatedProviderRewardsRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryEstimatedProviderRewardsRequest",
    is(o) {
        return o && (o.$typeUrl === QueryEstimatedProviderRewardsRequest.typeUrl || typeof o.provider === "string" && typeof o.amountDelegator === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEstimatedProviderRewardsRequest.typeUrl || typeof o.provider === "string" && typeof o.amount_delegator === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEstimatedProviderRewardsRequest.typeUrl || typeof o.provider === "string" && typeof o.amount_delegator === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.provider !== "") {
            writer.uint32(10).string(message.provider);
        }
        if (message.amountDelegator !== "") {
            writer.uint32(18).string(message.amountDelegator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEstimatedProviderRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.provider = reader.string();
                    break;
                case 2:
                    message.amountDelegator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            provider: isSet(object.provider) ? String(object.provider) : "",
            amountDelegator: isSet(object.amountDelegator) ? String(object.amountDelegator) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.provider !== undefined && (obj.provider = message.provider);
        message.amountDelegator !== undefined && (obj.amountDelegator = message.amountDelegator);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEstimatedProviderRewardsRequest();
        message.provider = object.provider ?? "";
        message.amountDelegator = object.amountDelegator ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEstimatedProviderRewardsRequest();
        if (object.provider !== undefined && object.provider !== null) {
            message.provider = object.provider;
        }
        if (object.amount_delegator !== undefined && object.amount_delegator !== null) {
            message.amountDelegator = object.amount_delegator;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.provider = message.provider === "" ? undefined : message.provider;
        obj.amount_delegator = message.amountDelegator === "" ? undefined : message.amountDelegator;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEstimatedProviderRewardsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEstimatedProviderRewardsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryEstimatedProviderRewardsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryEstimatedProviderRewardsRequest",
            value: QueryEstimatedProviderRewardsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEstimatedProviderRewardsRequest.typeUrl, QueryEstimatedProviderRewardsRequest);
function createBaseEstimatedRewardInfo() {
    return {
        source: "",
        amount: []
    };
}
export const EstimatedRewardInfo = {
    typeUrl: "/lavanet.lava.subscription.EstimatedRewardInfo",
    is(o) {
        return o && (o.$typeUrl === EstimatedRewardInfo.typeUrl || typeof o.source === "string" && Array.isArray(o.amount) && (!o.amount.length || DecCoin.is(o.amount[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === EstimatedRewardInfo.typeUrl || typeof o.source === "string" && Array.isArray(o.amount) && (!o.amount.length || DecCoin.isSDK(o.amount[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === EstimatedRewardInfo.typeUrl || typeof o.source === "string" && Array.isArray(o.amount) && (!o.amount.length || DecCoin.isAmino(o.amount[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.source !== "") {
            writer.uint32(10).string(message.source);
        }
        for (const v of message.amount) {
            DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEstimatedRewardInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.source = reader.string();
                    break;
                case 2:
                    message.amount.push(DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            source: isSet(object.source) ? String(object.source) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e) => DecCoin.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.source !== undefined && (obj.source = message.source);
        if (message.amount) {
            obj.amount = message.amount.map(e => e ? DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.amount = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseEstimatedRewardInfo();
        message.source = object.source ?? "";
        message.amount = object.amount?.map(e => DecCoin.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseEstimatedRewardInfo();
        if (object.source !== undefined && object.source !== null) {
            message.source = object.source;
        }
        message.amount = object.amount?.map(e => DecCoin.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.source = message.source === "" ? undefined : message.source;
        if (message.amount) {
            obj.amount = message.amount.map(e => e ? DecCoin.toAmino(e) : undefined);
        }
        else {
            obj.amount = message.amount;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return EstimatedRewardInfo.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return EstimatedRewardInfo.decode(message.value);
    },
    toProto(message) {
        return EstimatedRewardInfo.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.EstimatedRewardInfo",
            value: EstimatedRewardInfo.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(EstimatedRewardInfo.typeUrl, EstimatedRewardInfo);
function createBaseQueryEstimatedRewardsResponse() {
    return {
        info: [],
        total: [],
        recommendedBlock: BigInt(0)
    };
}
export const QueryEstimatedRewardsResponse = {
    typeUrl: "/lavanet.lava.subscription.QueryEstimatedRewardsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryEstimatedRewardsResponse.typeUrl || Array.isArray(o.info) && (!o.info.length || EstimatedRewardInfo.is(o.info[0])) && Array.isArray(o.total) && (!o.total.length || DecCoin.is(o.total[0])) && typeof o.recommendedBlock === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEstimatedRewardsResponse.typeUrl || Array.isArray(o.info) && (!o.info.length || EstimatedRewardInfo.isSDK(o.info[0])) && Array.isArray(o.total) && (!o.total.length || DecCoin.isSDK(o.total[0])) && typeof o.recommended_block === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEstimatedRewardsResponse.typeUrl || Array.isArray(o.info) && (!o.info.length || EstimatedRewardInfo.isAmino(o.info[0])) && Array.isArray(o.total) && (!o.total.length || DecCoin.isAmino(o.total[0])) && typeof o.recommended_block === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.info) {
            EstimatedRewardInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.total) {
            DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.recommendedBlock !== BigInt(0)) {
            writer.uint32(24).uint64(message.recommendedBlock);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEstimatedRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.info.push(EstimatedRewardInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push(DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.recommendedBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            info: Array.isArray(object?.info) ? object.info.map((e) => EstimatedRewardInfo.fromJSON(e)) : [],
            total: Array.isArray(object?.total) ? object.total.map((e) => DecCoin.fromJSON(e)) : [],
            recommendedBlock: isSet(object.recommendedBlock) ? BigInt(object.recommendedBlock.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map(e => e ? EstimatedRewardInfo.toJSON(e) : undefined);
        }
        else {
            obj.info = [];
        }
        if (message.total) {
            obj.total = message.total.map(e => e ? DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.total = [];
        }
        message.recommendedBlock !== undefined && (obj.recommendedBlock = (message.recommendedBlock || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEstimatedRewardsResponse();
        message.info = object.info?.map(e => EstimatedRewardInfo.fromPartial(e)) || [];
        message.total = object.total?.map(e => DecCoin.fromPartial(e)) || [];
        message.recommendedBlock = object.recommendedBlock !== undefined && object.recommendedBlock !== null ? BigInt(object.recommendedBlock.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEstimatedRewardsResponse();
        message.info = object.info?.map(e => EstimatedRewardInfo.fromAmino(e)) || [];
        message.total = object.total?.map(e => DecCoin.fromAmino(e)) || [];
        if (object.recommended_block !== undefined && object.recommended_block !== null) {
            message.recommendedBlock = BigInt(object.recommended_block);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map(e => e ? EstimatedRewardInfo.toAmino(e) : undefined);
        }
        else {
            obj.info = message.info;
        }
        if (message.total) {
            obj.total = message.total.map(e => e ? DecCoin.toAmino(e) : undefined);
        }
        else {
            obj.total = message.total;
        }
        obj.recommended_block = message.recommendedBlock !== BigInt(0) ? (message.recommendedBlock?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEstimatedRewardsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEstimatedRewardsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryEstimatedRewardsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryEstimatedRewardsResponse",
            value: QueryEstimatedRewardsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEstimatedRewardsResponse.typeUrl, QueryEstimatedRewardsResponse);
function createBaseQueryEstimatedValidatorRewardsRequest() {
    return {
        validator: "",
        amountDelegator: ""
    };
}
export const QueryEstimatedValidatorRewardsRequest = {
    typeUrl: "/lavanet.lava.subscription.QueryEstimatedValidatorRewardsRequest",
    is(o) {
        return o && (o.$typeUrl === QueryEstimatedValidatorRewardsRequest.typeUrl || typeof o.validator === "string" && typeof o.amountDelegator === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEstimatedValidatorRewardsRequest.typeUrl || typeof o.validator === "string" && typeof o.amount_delegator === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEstimatedValidatorRewardsRequest.typeUrl || typeof o.validator === "string" && typeof o.amount_delegator === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.validator !== "") {
            writer.uint32(10).string(message.validator);
        }
        if (message.amountDelegator !== "") {
            writer.uint32(18).string(message.amountDelegator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEstimatedValidatorRewardsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validator = reader.string();
                    break;
                case 2:
                    message.amountDelegator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            validator: isSet(object.validator) ? String(object.validator) : "",
            amountDelegator: isSet(object.amountDelegator) ? String(object.amountDelegator) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator);
        message.amountDelegator !== undefined && (obj.amountDelegator = message.amountDelegator);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEstimatedValidatorRewardsRequest();
        message.validator = object.validator ?? "";
        message.amountDelegator = object.amountDelegator ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEstimatedValidatorRewardsRequest();
        if (object.validator !== undefined && object.validator !== null) {
            message.validator = object.validator;
        }
        if (object.amount_delegator !== undefined && object.amount_delegator !== null) {
            message.amountDelegator = object.amount_delegator;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.validator = message.validator === "" ? undefined : message.validator;
        obj.amount_delegator = message.amountDelegator === "" ? undefined : message.amountDelegator;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEstimatedValidatorRewardsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEstimatedValidatorRewardsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryEstimatedValidatorRewardsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryEstimatedValidatorRewardsRequest",
            value: QueryEstimatedValidatorRewardsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEstimatedValidatorRewardsRequest.typeUrl, QueryEstimatedValidatorRewardsRequest);
function createBaseQueryEstimatedValidatorRewardsResponse() {
    return {
        info: [],
        total: []
    };
}
export const QueryEstimatedValidatorRewardsResponse = {
    typeUrl: "/lavanet.lava.subscription.QueryEstimatedValidatorRewardsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryEstimatedValidatorRewardsResponse.typeUrl || Array.isArray(o.total) && (!o.total.length || DecCoin.is(o.total[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryEstimatedValidatorRewardsResponse.typeUrl || Array.isArray(o.total) && (!o.total.length || DecCoin.isSDK(o.total[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryEstimatedValidatorRewardsResponse.typeUrl || Array.isArray(o.total) && (!o.total.length || DecCoin.isAmino(o.total[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.info) {
            EstimatedRewardInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.total) {
            DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryEstimatedValidatorRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.info.push(EstimatedRewardInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push(DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            info: Array.isArray(object?.info) ? object.info.map((e) => EstimatedRewardInfo.fromJSON(e)) : [],
            total: Array.isArray(object?.total) ? object.total.map((e) => DecCoin.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map(e => e ? EstimatedRewardInfo.toJSON(e) : undefined);
        }
        else {
            obj.info = [];
        }
        if (message.total) {
            obj.total = message.total.map(e => e ? DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.total = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryEstimatedValidatorRewardsResponse();
        message.info = object.info?.map(e => EstimatedRewardInfo.fromPartial(e)) || [];
        message.total = object.total?.map(e => DecCoin.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryEstimatedValidatorRewardsResponse();
        message.info = object.info?.map(e => EstimatedRewardInfo.fromAmino(e)) || [];
        message.total = object.total?.map(e => DecCoin.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.info) {
            obj.info = message.info.map(e => e ? EstimatedRewardInfo.toAmino(e) : undefined);
        }
        else {
            obj.info = message.info;
        }
        if (message.total) {
            obj.total = message.total.map(e => e ? DecCoin.toAmino(e) : undefined);
        }
        else {
            obj.total = message.total;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryEstimatedValidatorRewardsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryEstimatedValidatorRewardsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryEstimatedValidatorRewardsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.subscription.QueryEstimatedValidatorRewardsResponse",
            value: QueryEstimatedValidatorRewardsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryEstimatedValidatorRewardsResponse.typeUrl, QueryEstimatedValidatorRewardsResponse);
